export const TENANT_STORAGE_KEY = "x-tenant-id";
